const _ = require('lodash');
const { CurrencyConverter } = require('@fiverr-private/futile/bundle');
const { FILTER, SELECTED_DEFAULTS } = require('../../config/filters');
const { getFilterSelectedOption } = require('./_utils');

const priceRangeFilterId = FILTER.GIG_PRICE_RANGE.ID;
const priceRangeDefaults = FILTER.GIG_PRICE_RANGE.DEFAULTS;
const languagePairFilterId = FILTER.LANGUAGES_PAIR.ID;

const aliasTemplates = [
    ({ min, max, UNDER, maxFormatted }) => min === priceRangeDefaults.MIN && max && `${UNDER} ${maxFormatted}`,
    ({ min, max, OVER, minFormatted }) => max === priceRangeDefaults.MAX && min && `${OVER} ${minFormatted}`,
    ({ min, max, minFormatted, maxFormatted }) => min && max && `${minFormatted} - ${maxFormatted}`
];

const selectedHandlers = {
    [priceRangeFilterId]({ options = [] }, { currency, translationsService }){
        const { min, max } = (options[0] || {});

        if (!(min || max) || (max === priceRangeDefaults.MAX && min === priceRangeDefaults.MIN)) {
            return [];
        }

        const [OVER, UNDER] = translationsService.general.translate('search_perseus.filter_builder.selected.price_range.over_under');

        const converter = new CurrencyConverter(currency);
        const properties = { commaSeparate: true, convertRate: false };

        const minFormatted = converter.convert(min, properties);
        const maxFormatted = converter.convert(max, properties);

        const template = aliasTemplates.find((template) => template({ min, max }));
        const alias = template && template({ min, max, OVER, UNDER, minFormatted, maxFormatted });

        return [{ id: priceRangeFilterId, alias, selector: FILTER.GIG_PRICE_RANGE.SELECTOR }];
    },
    [languagePairFilterId]({ id, options: { fromOptions, toOptions } }, { translationsService }){
        const { FROM, TO } = FILTER.LANGUAGES_PAIR.TYPES;
        return [{ filterId: id, options: fromOptions, type: FROM },
            { filterId: id, options: toOptions, type: TO }].reduce((acc, { filterId, options, type }) => {

            const selected = getFilterSelectedOption({ id: filterId, options });

            if (!selected.length) {
                return acc;
            }

            const [{ id, alias, value }] = selected;
            acc.push({ id, alias: translationsService.general.translate(`search_perseus.filter_builder.selected.pair.${type}`, { alias }), value });
            return acc;
        }, []);
    }
};

const isDefaultOption = (id, value) => SELECTED_DEFAULTS[id] !== undefined && _.isEqual(SELECTED_DEFAULTS[id], value);

module.exports = {
    clearActiveDefaults: (activeFilters = {}) => {
        if (!activeFilters) {
            return {};
        }

        Object.keys(activeFilters).forEach((key) => {
            const value = activeFilters[key];

            if (isDefaultOption(key, value)) {
                activeFilters[key] = undefined;
            }
        });

        return activeFilters;
    },
    handler(filter, additionalArgs){
        const selected = selectedHandlers[filter.id] ?
            selectedHandlers[filter.id](filter, additionalArgs) :
            getFilterSelectedOption(filter);

        return selected.filter(({ id, value }) => !isDefaultOption(id, value));
    },
    isDefaultOption
};
